export default () => ({
  message: {
    type: null,
    text: null,
  },
  securityMessage: '',
  postLoginPath: null,
})
